/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'weather-sunny': {
    width: 16,
    height: 16,
    viewBox: '0 0 17.31 20',
    data: '<path pid="0" d="M8.66 5a5 5 0 0 1 5 5 5 5 0 0 1-5 5 5 5 0 0 1-5-5 5 5 0 0 1 5-5zm0 2a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3zm0-7l2.39 3.42A6.981 6.981 0 0 0 8.66 3a6.981 6.981 0 0 0-2.39.42L8.66 0zM0 5l4.16-.35A7.2 7.2 0 0 0 2.6 6.5a6.666 6.666 0 0 0-.83 2.29L0 5zm.02 10l1.76-3.77a7 7 0 0 0 .83 2.27 7.133 7.133 0 0 0 1.55 1.87L.02 15zM17.31 5l-1.77 3.79a7.023 7.023 0 0 0-.83-2.29 7.215 7.215 0 0 0-1.55-1.86l4.15.36zm-.01 10l-4.14.36a7.385 7.385 0 0 0 1.54-1.86 7.024 7.024 0 0 0 .83-2.29L17.3 15zm-8.64 5l-2.41-3.44a7.017 7.017 0 0 0 2.41.44 6.968 6.968 0 0 0 2.37-.44L8.66 20z" fill-rule="evenodd"/>'
  }
})
